import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {PlusOutlined} from '@ant-design/icons';
import {Button, Card, Col, Image, Row, Typography} from 'antd';
import GaragePlaceholder from 'assets/images/car_placeholder.svg';
import {ImageSkeleton} from 'components/ImageSkeleton';
import {Shell} from 'components/Shell';
import {observer} from 'mobx-react-lite';
import {AppRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';
import {GarageDto} from '../../../../../PRMGApiClient';
import {imageErrorCallback} from 'helpers/utils';

export const GarageListView: React.FC = observer((): JSX.Element => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  return (
    <Shell
      title={t('Garages')}
      actionButtons={[
        <Button
          type="primary"
          key="add"
          size="large"
          icon={<PlusOutlined />}
          onClick={() => navigate(AppRoutePaths.garageCreate.url)}
          className="shell-btn"
        >
          {t('Add Garage')}
        </Button>,
      ]}
    >
      {appState.commonData?.garages?.length ? (
        <Row gutter={[16, 16]}>
          {appState.commonData?.garages?.map((garage: GarageDto) => (
            <Col key={garage.id} className="gutter-row" xs={24} sm={24} md={12} lg={6} xl={6}>
              <Card
                hoverable
                cover={
                  <div className="overflow-hidden h-52">
                    <Image
                      height="100%"
                      width="100%"
                      className="object-cover rounded-lg"
                      src={garage.photo?.url ? garage.photo.url : GaragePlaceholder}
                      placeholder={<ImageSkeleton />}
                      preview={false}
                      onError={(e) => garage.photo && imageErrorCallback(e, garage.photo)}
                    />
                  </div>
                }
                onClick={() => navigate(`${AppRoutePaths.garages.url}/${garage.id}`)}
              >
                <Card.Meta title={garage.name} description={t('Number of vehicles: ') + garage.carsCount ?? 0} />
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <Typography.Text italic>{t('No garages found')}</Typography.Text>
      )}
    </Shell>
  );
});
